import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StringExtensionsService {
  constructor() {}

  // Capitalize the first letter of a given string
  capitalize(str: string) {
    return String(str[0]).toUpperCase() + String(str).slice(1);
  }
}
